import api from './api';

const dashboardService = {
  // Get movies count
  getMoviesCount: () => {
    return api.get('/admin/count/movies');
  },

  // Get transactions count
  getTransactionsCount: () => {
    return api.get('/admin/count/transactions');
  },

  // Get users count
  getUsersCount: () => {
    return api.get('/admin/count/users');
  },

  // Get shows count
  getShowsCount: () => {
    return api.get('/admin/count/shows');
  },

  // Get all dashboard counts
  getAllCounts: async () => {
    try {
      const [movies, transactions, users, shows] = await Promise.all([
        dashboardService.getMoviesCount(),
        dashboardService.getTransactionsCount(),
        dashboardService.getUsersCount(),
        dashboardService.getShowsCount()
      ]);

      return {
        movies: movies.data?.count || 0,
        transactions: transactions.data?.count || 0,
        users: users.data?.count || 0,
        shows: shows.data?.count || 0
      };
    } catch (error) {
      console.error('Error fetching dashboard counts:', error);
      return {
        movies: 0,
        transactions: 0,
        users: 0,
        shows: 0
      };
    }
  },

  // Get dashboard analytics data
  getAnalyticsData: () => {
    return api.get('/admin/analytics/dashboard');
  },

  // Get sales data
  getSalesData: (params = {}) => {
    return api.get('/admin/analytics/sales', { params });
  },

  // Get user analytics
  getUserAnalytics: (params = {}) => {
    return api.get('/admin/analytics/users', { params });
  },

  // Get revenue data
  getRevenueData: (params = {}) => {
    return api.get('/admin/analytics/revenue', { params });
  }
};

export default dashboardService;
